import type { AppSplitButtonProps } from "./AppSplitButton.Props";

export const isAppSplitButtonProps = (props: {
  type: string;
}): props is AppSplitButtonProps => {
  return (props as AppSplitButtonProps).type === "AppSplitButtonProps";
};
